var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"qjc-fts-20 qjc-c-dark qjc-ftw-500"},[_vm._v("数据录入 ")]),_c('data-template',{attrs:{"type":"insert","clearData":_vm.clearData,"formData":_vm.formData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }